"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Options_1 = __importDefault(require("../Options"));
const connector_1 = require("@maxeb/connector");
const IDP = {
    whoAMI: () => __awaiter(void 0, void 0, void 0, function* () {
        return (0, connector_1.createGET)(Options_1.default.buildPath("/idp/whoami"), Options_1.default.getApiKey())({}, [], 1);
    }),
    register: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/register"), Options_1.default.getApiKey())(data);
    },
    login: (data) => __awaiter(void 0, void 0, void 0, function* () {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/login"), Options_1.default.getApiKey())(data);
    }),
    challengeEmail: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/challenge/email"), Options_1.default.getApiKey())(data);
    },
    challengeEmailNew: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/challenge/email/new"), Options_1.default.getApiKey())(data);
    },
    challengePassword: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/challenge/password"), Options_1.default.getApiKey())(data);
    },
    resetPassword: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/reset/password"), Options_1.default.getApiKey())(data);
    },
    logout: () => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/logout"), Options_1.default.getApiKey())({});
    },
    addTeam: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/team"), Options_1.default.getApiKey())(Object.assign(Object.assign({}, data), { swap: false }));
    },
    leaveTeam: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/team/leave"), Options_1.default.getApiKey())(data);
    },
    getTeam: (data) => {
        return (0, connector_1.createGET)(Options_1.default.buildPath("/idp/team"), Options_1.default.getApiKey())(data, [], 1);
    },
    updateTeam: (set, where) => {
        return (0, connector_1.createPATCH)(Options_1.default.buildPath("/idp/team"), Options_1.default.getApiKey())(where, set);
    },
    removeTeam: (where) => {
        return (0, connector_1.createDELETE)(Options_1.default.buildPath("/idp/team"), Options_1.default.getApiKey())(where);
    },
    addTeamAndSwap: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/team"), Options_1.default.getApiKey())(Object.assign(Object.assign({}, data), { swap: true }));
    },
    swapTeam: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/team/swap"), Options_1.default.getApiKey())(data);
    },
    acceptTeam: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/idp/invite"), Options_1.default.getApiKey())(data);
    },
    rejectTeam: (data) => {
        return (0, connector_1.createDELETE)(Options_1.default.buildPath("/idp/invite"), Options_1.default.getApiKey())(data);
    },
    getSettings: (condition) => {
        return (0, connector_1.createGET)(Options_1.default.buildPath("/idp/settings"), Options_1.default.getApiKey())(condition, [], 1);
    },
    settings: (settings, condition) => {
        return (0, connector_1.createPATCH)(Options_1.default.buildPath("/idp/settings"), Options_1.default.getApiKey())(condition, settings);
    },
};
exports.default = IDP;
